import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../pages/auth/login";
import FbsPage from "../pages/dashboard/fbs";
import RequireAuth from "./RequireAuth";
import KizWithdrawalPage from "../pages/dashboard/kiz-withdrawal";
import ReturnsPage from "../pages/dashboard/returns";
import StickerEditorPage from "../pages/dashboard/sticker-editor";
import UnitEconomicsPage from "../pages/dashboard/unit-economics";
import PreparationRequestsPage from "../pages/dashboard/preparation-requests";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/dashboard/fbs" replace />} />
      <Route
        path="/dashboard/fbs"
        element={
          <RequireAuth>
            <FbsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard/returns"
        element={
          <RequireAuth>
            <ReturnsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard/preparation-requests"
        element={
          <RequireAuth>
            <PreparationRequestsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard/kiz"
        element={
          <RequireAuth>
            <KizWithdrawalPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard/stickers"
        element={
          <RequireAuth>
            <StickerEditorPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard/unit-economics"
        element={
          <RequireAuth>
            <UnitEconomicsPage />
          </RequireAuth>
        }
      />
      <Route
        path="*"
        element={<div style={{ padding: 24 }}>Страница не найдена</div>}
      />
    </Routes>
  );
}
